<template>
  <div :class="$style.container">
    <DolphinSelector
      v-model="typeForm"
      :options="resourceOptions"
      :class="$style.inputType"
    />
    <div
      v-if="model.type !== 'AnyAuthzPolicyResource'"
      :class="$style.inputEachField"
    >
      <p>対象のid:</p>
      <DolphinTextInput v-model="model.id" :class="$style.inputText" />
    </div>
  </div>
</template>

<script lang="ts" setup>
import { computed, watch } from 'vue'
import {
  AuthzPolicyResourceTypeValues,
  AuthzPolicyResourceTypeText,
  PossibleResourceTypes,
  type AuthzPolicyActionType,
} from '../types'
import DolphinSelector from '@/components/atoms/DolphinSelector.vue'
import DolphinTextInput from '@/components/atoms/DolphinTextInput.vue'

type AnyAuthzPolicyResource = {
  type: 'AnyAuthzPolicyResource'
}
type RoomAuthzPolicyResource = {
  type: 'RoomAuthzPolicyResource'
  id: string
}

export type AuthzPolicyResourceForm =
  | AnyAuthzPolicyResource
  | RoomAuthzPolicyResource

const model = defineModel<AuthzPolicyResourceForm>({ required: true })

const props = defineProps<{
  actionType: AuthzPolicyActionType
}>()

const typeForm = computed({
  get: () => model.value.type,
  set: value => {
    switch (value) {
      case 'AnyAuthzPolicyResource':
        model.value = {
          type: value,
        }
        break
      case 'RoomAuthzPolicyResource':
        model.value = {
          type: value,
          id: '',
        }
        break
    }
  },
})

const resourceOptions = computed(() =>
  AuthzPolicyResourceTypeValues.filter(v =>
    PossibleResourceTypes[props.actionType].includes(v)
  ).map(v => ({
    value: v,
    text: AuthzPolicyResourceTypeText[v],
  }))
)

// アクションが変わったときにリソースタイプが合わなければリセットする
watch(
  () => props.actionType,
  () => {
    if (!PossibleResourceTypes[props.actionType].includes(model.value.type)) {
      model.value = {
        type: 'AnyAuthzPolicyResource',
      }
    }
  }
)
</script>

<style lang="scss" module>
.container {
  display: flex;
  flex-direction: column;
  gap: 24px;
}

.inputType {
  width: 200px;
}

.inputEachField {
  display: flex;
  gap: 8px;
  align-items: center;
}
</style>
